var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoKoi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 103,
    viewBox: "0 0 70 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1757_2500)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70 0H0V103H70V0Z",
    fill: "#1E1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.9906 101.014H2.00928V1.99017H67.9906V101.014ZM2.85822 100.248H67.1568V2.75151H2.85822V100.248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0137 28.1528H30.9136V29.0883L28.859 29.8795L13.8945 35.6269V44.3052L34.9925 36.1941L56.0905 44.3052V35.6269L41.1511 29.8795L39.0966 29.0883V28.1528H56.1758V16.6182C56.1758 16.6182 54.4127 19.2854 52.2275 19.4745H39.0966V16.6182H30.9136V19.4745H17.7675C15.5874 19.2854 13.8242 16.6182 13.8242 16.6182V28.1528H18.0137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.2426 77.1573H17.7675C15.5874 76.9682 13.8242 74.306 13.8242 74.306V85.8455H56.1859V74.306C56.1859 74.306 54.4227 76.9682 52.2426 77.1573Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9324 74.6746L41.0759 72.3109L56.0404 66.5636V49.416L41.0759 43.6686L34.9324 41.3099L28.7838 43.6686L13.8193 49.416V66.5636L28.7838 72.3109L34.9324 74.6746ZM19.3601 60.015V55.9894L21.0077 55.3574L29.1907 52.2175L34.9324 50.0131L40.6891 52.1926L48.8721 55.3325L50.5197 55.9645V60.015L48.8721 60.647L40.6891 63.7919L34.9525 65.9963L29.2108 63.7919L21.0278 60.647L19.3601 60.015Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1757_2500"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 103,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoKoi);
export default __webpack_public_path__ + "static/media/logo-koi.a90bf22859a53f53c421c7ae41437910.svg";
export { ForwardRef as ReactComponent };